import { PlusOutlined, UploadOutlined, } from "@ant-design/icons";
import { Button, message, Upload } from "antd";
import type { ColumnsType } from "antd/es/table";

import editIcon from "../../../../assets/icons/edit.png";
import { renderAntDMessageConfig } from "../../../../utils/renderAntDMessageConfig";
import { createUploadProps } from "../../utils/uploadProps";
import type { EditOptions, FeedbackType, } from "./dailyCheckInTypes"

export function createFeedbackColumns(
  handleEdit: (record: FeedbackType) => void,
): ColumnsType<FeedbackType> {
  return [
    {
      title: 'Character',
      dataIndex: 'characterName',
      key: 'characterName',
    },
    {
      title: 'Feedback options',
      dataIndex: 'feedbackOptions',
      key: 'feedbackOptions',
      render: (feedbackOptions) => feedbackOptions.length,
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record) => (
        <Button type="link" className="w-9 p-0" onClick={() => handleEdit(record)}>
          Edit
        </Button>
      ),
    },
  ];
}

export function createFeedbackOptionsColumns(
  setEditOptionsData: any,
  handleDelete: (record: EditOptions) => void,
): ColumnsType<EditOptions> {
  return [
    {
      title: "#",
      width: 50,
      render: (_, __, index) => (index + 1),
    },
    {
      title: 'Audio',
      dataIndex: 'audioFile',
      key: 'audioFile',
      render: (_, record) => (
        <Upload
          {...createUploadProps("mp3", "audio", 1)}
          fileList={record.audioFile}
          onChange={({ file, fileList }) => {
            setEditOptionsData((prev: EditOptions[]) =>
              prev?.map((item: EditOptions) =>
                item.feedbackId === record.feedbackId
                  ? { ...item, audioFile: fileList }
                  : item
              )
            );

            if (file.status === "done") {
              message.success(renderAntDMessageConfig(`${file.name} uploaded successfully`));
            } else if (file.status === "error") {
              message.error(renderAntDMessageConfig(`${file.name} upload failed`));
            }
          }}
          onRemove={(file) => {
            setEditOptionsData((prev: EditOptions[]) =>
              prev?.map((item: EditOptions) =>
                item.feedbackId === record.feedbackId
                  ? { ...item, audioFile: item.audioFile?.filter((f) => f.uid !== file.uid) }
                  : item
              )
            );
          }}
        >
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload>
      ),
    },
    {
      title: 'Badge image',
      dataIndex: 'badgeImageFile',
      key: 'badgeImageFile',
      render: (_, record) => (
        <Upload
          {...createUploadProps("png", "badgeImage", 1)}
          fileList={record.badgeImageFile}
          listType="picture-card"
          showUploadList={{
            removeIcon: (file) => (
              <div
                onClick={() => {
                  const input = document.createElement("input");
                  input.type = "file";
                  input.accept = ".png";
                  input.onchange = (e: any) => {
                    const newFile = e.target.files[0];
                    const isValid = ["image/png"].includes(newFile.type);

                    if (!isValid) {
                      message.error(renderAntDMessageConfig(`${newFile.name} is not a valid png file`));
                      return;
                    } else
                      message.success(renderAntDMessageConfig(`${newFile.name} file uploaded successfully`));

                    if (newFile) {
                      const updatedFile = {
                        uid: newFile.uid,
                        name: newFile.name,
                        status: "done",
                        originFileObj: newFile,
                      };
                      setEditOptionsData((prev: EditOptions[]) =>
                        prev.map((item) =>
                          item.feedbackId === record.feedbackId
                            ? { ...item, badgeImageFile: [updatedFile] }
                            : item
                        )
                      );
                    }
                  };
                  input.click();
                }}
              >
                <img
                  src={editIcon}
                  alt="edit"
                  style={{ width: 16, height: 16 }}
                />
              </div>
            ),
          }}
          onChange={({ file, fileList }) => {
            setEditOptionsData((prev: EditOptions[]) =>
              prev?.map((item: EditOptions) =>
                item.feedbackId === record.feedbackId
                  ? { ...item, badgeImageFile: fileList }
                  : item
              )
            );

            if (file.status === "done") {
              message.success(renderAntDMessageConfig(`${file.name} uploaded successfully`));
            } else if (file.status === "error") {
              message.error(renderAntDMessageConfig(`${file.name} upload failed`));
            }
          }}
          onRemove={() => false} 
        >
          {(!record.badgeImageFile || record.badgeImageFile.length === 0) && (
            <div style={{ position: "relative", textAlign: "center" }}>
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>Upload</div>
            </div>
          )}
        </Upload>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 80,
      render: (_, record, index) =>
        index === 0 ? null : (
          <Button
            type="link"
            className="w-9 p-0"
            onClick={() => handleDelete(record)}
          >
            Delete
          </Button>
        ),
    },
  ];
}